import { GetBaseUrl } from '@/utils/ConfigHelper'
import axios from "axios";
import Response from '@/utils/Videomonster/Common/Response'
import { PUBLIC_ERROR_CODE } from '@/utils/Error/Constants'
import { GetPublicErrorCode } from '@/utils/Error/Handler'

/**
 *  @throws {Error}
 *  @returns {Promise<Response>}
 */

const GetCreditsProducts = async () => {
    try {
        const url = `${GetBaseUrl()}/apis/credits/products`;
        const response = await axios.get(url);

        const result = (response.status === 200);
        const resultData = response.data.data;

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                return new Response(false, PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR)
        }
    }
}

/**
 *  @param {String} token
 *  @param {{
 *      offset: number,
 *      limit: number
 *  }} data
 *  @throws {Error}
 *  @returns {Promise<Response>}
 */

const PostCreditsSchedules = async (token, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/credits/schedules-hook`
        const config = { Authorization: `Bearer ${token}` }
        const response = await axios.post(url, data, { headers: config })
        const result = (response.status === 200)

        const resultData = response.data.data;

        return new Response(result, resultData)
    }
    catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                return new Response(false, PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR)
        }
    }

}

/**
 *  @param {String} token
 *  @throws {Error}
 *  @returns {Promise<Response>}
 */

const GetCurrentUserCredits = async (token) => {
    try {
        const url = `${GetBaseUrl()}/apis/credits/current-credit`;
        const config = { headers: { Authorization: `Bearer ${token}` } }
        const response = await axios.get(url, config);
        const result = (response.status === 200);
        const resultData = response.data.data;

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                return new Response(false, PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR)
        }
    }
}

/**
 *  @param {String} token
 *  @param {{
 *      productType: string,
 *      productCount: number
 *  }} data
 *  @throws {Error}
 *  @returns {Promise<Response>}
 */
const PostCreditsUse = async (token, data = {}) => {
    try {
        const { productType, productCount } = data;
        const url = `${GetBaseUrl()}/apis/credits/use`;
        const config = { headers: { Authorization: `Bearer ${token}` } }
        const body = {
            productType,
            productCount,
        }
        const response = await axios.post(url, body, config)
        const result = (response.status === 200)
        const resultData = response.data.data;

        return new Response(result, resultData)
    }
    catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_ENOUGH_POINT:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                return new Response(false, PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR)
        }
    }
}

export default {
    GetCreditsProducts,
    PostCreditsSchedules,
    GetCurrentUserCredits,
    PostCreditsUse,
}